/**
 * @readonly
 * @enum {Number}
 */
const numberOfChipsEnum = [
    1000,
    2000,
    5000,
    10000,
    25000,
    50000
]

const defaultNumberOfChips = 2000;

export {
    numberOfChipsEnum,
    defaultNumberOfChips
}
